import {escapeHtml} from './utils/escapeHtml.js';

export function initializeReportTable() {
	let table = $('#activity').DataTable({
		'processing': true,
		'serverSide': true,
		'ajax': {
			'url': '/report/get-datatable',
			'type': 'POST',
			'data': function (d) {
				// d.year = 2025;// test
			},
		},
		'columns': [
			{'data': 'label', 'title': 'Label', 'orderable': false},
			{'data': 'january', 'title': 'January', 'orderable': false},
			{'data': 'february', 'title': 'February', 'orderable': false},
			{'data': 'march', 'title': 'March', 'orderable': false},
			{'data': 'april', 'title': 'April', 'orderable': false},
			{'data': 'may', 'title': 'May', 'orderable': false},
			{'data': 'june', 'title': 'June', 'orderable': false},
			{'data': 'july', 'title': 'July', 'orderable': false},
			{'data': 'august', 'title': 'August', 'orderable': false},
			{'data': 'september', 'title': 'September', 'orderable': false},
			{'data': 'october', 'title': 'October', 'orderable': false},
			{'data': 'november', 'title': 'November', 'orderable': false},
			{'data': 'december', 'title': 'December', 'orderable': false},
		],
		'initComplete': function (settings, json) {
			function setupCells() {
				$('#activity tfoot th').each(function (index) {


					if (index === 0) {
						$(this).css({
							'cursor': 'pointer',
							'background': '#5aa2f938',
							'font-weight': '500',
						});
					}
					if (index > 0) {
						$(this).css({
							'color': '#555555',
							'text-decoration': 'none',
							'cursor': 'pointer',
							'background': '#5aa2f938',
							'font-weight': '500',
						});

						$(this).on('click', function () {
							var month = $(this).data('month') ? $(this).data('month').toLowerCase() : $(this).text().toLowerCase();
							let year = new Date().getFullYear() + '/';

							var url = '/report/activity/' + year + month;

							window.location.href = url;
						});
					}
				});
			}

			setupCells();
		},

	});


	let url = window.location.pathname;
	let segments = url.split('/');
	let month = segments[segments.length - 1];


	let table_all_submission = $('#all_submission').DataTable({


		'processing': true,
		'serverSide': false,
		'ajax': {
			'url': 'all-submission',
			'type': 'POST',
			'data': function (d) {
				d.month = month;
			},
			'dataSrc': 'data',
		},
		'columns': [
			{'data': 'filed', 'title': 'Filed', 'orderable': false},
			{'data': 'duplicates', 'title': 'Duplicates', 'orderable': false},
			{'data': 'excluded', 'title': 'Excluded', 'orderable': false},
			{'data': 'total', 'title': 'Total Amount', 'orderable': false},
		],
	});


	let filed_submission = $('#filed_submission').DataTable({
		'processing': true,
		'serverSide': false,
		'ajax': {
			'url': 'filed-submission',
			'type': 'POST',
			'data': function (d) {
				d.month = month;
			},
			'dataSrc': 'data',
		},
		'columns': [
			{'data': 'dot', 'title': 'DOT', 'orderable': false},
			{'data': 'company_name', 'title': 'Insured Name', 'orderable': false},
			{
				'data': 'ai_efficiency', 'title': 'Effeciency', 'orderable': false,
				'render': function (data, type, row) {
					return escapeHtml(Number.parseFloat(data).toFixed(2));
				},
			},
			{
				'data': 'tokens', 'title': 'Qty Tokens', 'orderable': false,
				'render': function (data, type, row) {
					return escapeHtml(Number.parseFloat(data).toFixed(2));
				},
			},
			{
				'data': 'cost_tokens', 'title': 'Token Cost', 'orderable': false,
				'render': function (data, type, row) {
					return escapeHtml(Number.parseFloat(data).toFixed(2));
				},
			},
			// {"data": "cost_tokens", "title": "Token Cost", "orderable": false},
			{
				'data': 'cost_license', 'title': 'License price', 'orderable': false,
			},
			{
				'data': 'total_cost', 'title': 'Total Amount', 'orderable': false,
				'render': function (data, type, row) {
					return escapeHtml(Number.parseFloat(data).toFixed(2));
				},
			},
		],
	});

	let excluded_submission = $('#excluded_submission').DataTable({
		'processing': true,
		'serverSide': false,
		'ajax': {
			'url': 'excluded-submission',
			'type': 'POST',
			'data': function (d) {
				d.month = month;
			},
			'dataSrc': 'data',
		},
		'columns': [
			{'data': 'dot', 'title': 'DOT', 'orderable': false},
			{'data': 'company_name', 'title': 'Insured Name', 'orderable': false},
			{'data': 'ai_efficiency', 'title': 'Effeciency', 'orderable': false},
			{
				'data': 'tokens', 'title': 'Qty Tokens', 'orderable': false,
				'render': function (data, type, row) {
					return escapeHtml(Number.parseFloat(data).toFixed(2));
				},
			},
			{
				'data': 'cost_tokens', 'title': 'Token Cost', 'orderable': false,
				'render': function (data, type, row) {
					return escapeHtml(Number.parseFloat(data).toFixed(2));
				},
			},
			// {"data": "cost_tokens", "title": "Token Cost", "orderable": false},
			{
				'data': 'cost_license', 'title': 'License price', 'orderable': false,
			},
			{
				'data': 'total_cost', 'title': 'Total Amount', 'orderable': false,
				'render': function (data, type, row) {
					return escapeHtml(Number.parseFloat(data).toFixed(2));
				},
			},
		],
	});


}
